<template>
    <div class="paddingH16">
        <div class="atlasList  gridLayout grid2column marginT24">

            <div class="atlasSingular roundBorder8 hiddenOverflow"
                 v-for="dataItem in dataList" :key="dataItem.id" @click="viewItem(dataItem)">
                <div class="atlasImage roundBorder8">
                    <img class="fullSpace" :src="dataItem.coverImg">
                </div>
                <div class="atlasCharacter bgFAFAFA">
                    <div class="atlasTitle font14r bold color333">{{dataItem.title}}</div>
                    <div class="priceArea f14" style="height: 17px; line-height: 17px;">
                        <span class="gold" v-if="dataItem.chargeMode == 'FREE'">免费</span>
                        <template v-else>

                            <i class="icon atlasVipIcon fl marginR4" v-if="dataItem.isVip"></i>
                            <span class="gold">￥{{dataItem.price}}</span>
                        </template>

                    </div>
                    <div class="atlasNumber marginT8 clearfix" style="line-height: 20px">
                        <div class="atlasUser floatL" style="line-height: 24px;">
                            <div class="atlasUserImage marginR4">
                                <img class="size24 circle" :src="dataItem.userImg">
                            </div>
                            <div class="atlasUserName font12r" style="color: hsla(219, 9%, 39%, 1)">{{dataItem.userName}}</div>
                        </div>
                        <div class="fr f10 grey">
                            <i class="icon greyViewIcon alignM fl" style="width: 14px; height: 14px; margin-top: 3px;"></i>
                            {{dataItem.pv}}
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- 暂时搜不到内容，搜搜其他内容吧 -->
        <div class="alignC paddingT20 font14r" v-show="dataList.length < 1">
            <img src="notice/notice_no_search_result.png" width="282"/><br/>
            暂时搜不到内容，可
            <span class="blue" @click="contact()">联系师讯客服</span>
            搜索更多内容
        </div>

        <div class="font12r grey60 alignCenter" style="padding: 26px 0 9px;"
             v-show="status=='ready' && pagination.current == pagination.totalPage"
             :data-current="pagination.current" :data-total="pagination.totalPage || 0">
            -没有更多啦-
        </div>

    </div>
</template>

<script>

import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import bizTypeEnum from '@data/bizTypeEnum';
import externalApp from '@data/externalApp';

// util
import appHelper from '@util/appHelper';

const config = {
    apiConfig : {
        list : {
            url : 'portal/v4/index/search',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
            params : {
                bizType : bizTypeEnum.ATLAS.code
            }
        }
    }
};

export default {
    name: 'atlasList',
    extends : shixunPagePart,
    data () {
        return {
            apiConfig: config.apiConfig,
            enableDataList : true,
            scrollToLoadNextPage : true
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.goToPage('atlasDetail', {
                id : dataItem.id
            });
        },
        contact() {
            appHelper.redirect(externalApp.oldShixun.baseUrl + 'html/me/contact.html');
        }
    }
};
</script>
<style lang="scss" scoped>
.atlasList {

    .dataListNull {
        width: 300px;
        height: 300px;
        color: red;
        text-align: center;
    }
    grid-column-gap: 17px;
    grid-row-gap: 16px;

    .atlasSingular {
        //width: 43.833vw;
        //height: 56.53vw;
        //margin: 14px 0 0 4.444vw;
        background-color: hsla(0, 0%, 97%, 1);

        .atlasImage {

            position: relative;
            //width: 43.833vw;
            height: 33vw;

        }

        .atlasCharacter {
            padding: 0 9px;

            .atlasTitle {
                padding-top: 2.778vw;
                overflow: hidden;
                text-overflow: ellipsis;
                /*white-space: nowrap;*/
                line-height: 18px;
                height: 36px;
                margin-bottom: 16px;
            }

            .atlasNumber {

                .atlasUser {
                    display: flex;
                    margin-top: -0.833vw;
                    line-height: 16px;
                }
            }
        }
    }
}
.grey {
    color: #B8C2D6;
}
.gold {
    color: #C9821A;
}
.atlasVipIcon {
    width: 76px;
    height: 17px;
    background-image: url('data:image/png;base64,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');
    background-repeat: no-repeat;
}
</style>
